/**
 * Service custom per la traduzione dei messaggi kendo
 * Ref: https://www.telerik.com/kendo-angular-ui/components/globalization/localization/messages/#toc-using-the-message-service
 */
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from '@progress/kendo-angular-l10n';

@Injectable({
  providedIn: 'any',  // 'any' : Provides a unique instance in each lazy loaded module while all eagerly loaded modules share one instance. Ref: https://angular.io/api/core/Injectable
})

export class AppKendoTranslateService extends MessageService {
  constructor(private translate: TranslateService) {
    super();
  }

  public override get(key: string): string {
    return this.translate.instant(key);
  }
}
